<template>
  <div class="plate ltr">
    <div class="left">
      <img src="/img/icons/iran_flag.jpg" />
      <span class="ir">I.R</span>
      <span class="iran">IRAN</span>
    </div>

    <div class="center">
      <input
        :required="required"
        ref="two_digits"
        v-model="twoDigits"
        :data-index="1"
        type="bumber"
        @keyup="changed_plaque"
        class="car_number_two_digits form-control not_arrow ltr text-center bold p-0"
        maxlength="2"
        autocomplete="off"
        :class="[
          errorMessage.two_digits && 'tw-border-red-200',
          size === 'sm' ? '!tw-w-[29px]' : '!tw-w-[35px]'
        ]"
      />
      <select
        v-model="letter"
        class="car_number_letter form-control tw-text-center py-0 px-1"
        @change="changed_plaque"
        :class="[
          size === 'sm' ? 'tw-w-[40px]' : 'tw-w-[45px]',
          errorMessage.letter && 'tw-border-red-200'
        ]"
      >
        <option value="">-</option>
        <option
          v-for="(letter, index) in alefba"
          :key="index"
          :value="letter"
          v-text="letter"
        ></option>
      </select>
      <input
        :required="required"
        ref="three_digits"
        v-model="threeDigits"
        type="bumber"
        @keyup="changed_plaque"
        :data-index="2"
        class="car_number_three_digits form-control not_arrow ltr text-center bold p-0"
        maxlength="3"
        autocomplete="off"
        :class="[
          size === 'sm' ? 'tw-w-[45px]' : 'tw-w-[50px]',
          errorMessage.three_digits && '!tw-border-red-200'
        ]"
      />
    </div>
    <div class="right">
      <input
        :required="required"
        ref="number_base"
        v-model="numberBase"
        :data-index="3"
        @keyup="changed_plaque"
        type="bumber"
        class="car_number_base form-control not_arrow ltr text-center fs-15 bold mx-auto p-0"
        maxlength="2"
        autocomplete="off"
        :class="errorMessage.number_base && '!tw-border-red-200'"
      />
    </div>
  </div>
  <p v-if="typeof errorMessage === 'string' && !!errorMessage" class="tw-text-red-400 tw-text-tiny tw-mb-0" v-text="errorMessage"></p>
</template>

<script>
export default
{
  name: 'Plate',
  props: {
    errorMessage: {
      type: [Object, String],
      default: {
        letter: null,
        two_digits: null,
        three_digits: null,
        number_base: null,
      }
    },
    plate: {
      type: Object,
      default: null,
    },
    car: {
      type: Object,
      default: null,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    default_letter: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'md'
    },
    required: {
      type: Boolean,
      default: true
    },
    useStore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localTwoDigits: null,
      localThreeDigits: null,
      localNumBaseDigits: null,
      localLetter: null,
    }
  },
  emits: ['update:plate', 'change', 'update:complete'],
  beforeMount() {
    if(typeof this.default_letter === 'string'){
      this.letter = this.default_letter.length > 0 ? this.default_letter : ''
    }
  },
  mounted() {
    if (this.car) {
      this.twoDigits = this.car.car_number_two_digits
      this.threeDigits = this.car.car_number_three_digits
      this.letter = this.car.car_number_letter
      this.numberBase = this.car.car_number_base
    }

    this.update_plate()
  },
  methods: {
    changed_plaque(event) {
      var index = event.target.getAttribute('data-index')
      var length = event.target.value.length

      if (index == 1 && length == 2) {
        this.$refs.three_digits.focus()
      } else if (index == 2) {
        if (!length && event.type === 'keyup' && event.code === 'Backspace') {
          this.$refs.two_digits.focus()
        } else if (length == 3) {
          this.$refs.number_base.focus()
        }
      } else if (
        index == 3 &&
        length == 0 &&
        event.type === 'keyup' &&
        event.code === 'Backspace'
      ) {
        this.$refs.three_digits.focus()
      }
      this.update_plate()
    },
    update_plate() {
      let plate_data = {
        number_base: this.numberBase || '',
        three_digits: this.threeDigits || '',
        two_digits: this.twoDigits || '',
        letter: this.letter || '',
      }
      this.$emit('update:plate', plate_data)
      this.$emit('change', plate_data)
      this.$emit('update:complete', this.is_complete())
    },
    is_complete() {
      if (
        this.twoDigits?.length === 2 &&
        this.threeDigits?.length === 3 &&
        this.numberBase?.length === 2 &&
        this.letter?.length
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    plate: {
      handler(newVal) {
        if (newVal) {
          this.twoDigits = newVal.two_digits || ''
          this.threeDigits = newVal.three_digits || ''
          this.letter = newVal.letter || ''
          this.numberBase = newVal.number_base || ''
        } else {
          this.twoDigits = ''
          this.threeDigits = ''
          this.letter = ''
          this.numberBase = ''
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  computed: {
    twoDigits: {
      get() {
        return this.useStore
          ? this.$store.state.two_digits
          : this.localTwoDigits
      },
      set(value) {
        if (this.useStore) {
          this.$store.state.two_digits = value
        } else {
          this.localTwoDigits = value
        }
      }
    },
    letter: {
      get() {
        return this.useStore
          ? this.$store.state.plate_letter
          : this.localLetter
      },
      set(value) {
        if (this.useStore) {
          this.$store.state.plate_letter = value
        } else {
          this.localLetter = value
        }
      }
    },
    threeDigits: {
      get() {
        return this.useStore
          ? this.$store.state.three_digits
          : this.localThreeDigits
      },
      set(value) {
        if (this.useStore) {
          this.$store.state.three_digits = value
        } else {
          this.localThreeDigits = value
        }
      }
    },
    numberBase: {
      get() {
        return this.useStore
          ? this.$store.state.number_base
          : this.localNumBaseDigits
      },
      set(value) {
        if (this.useStore) {
          this.$store.state.number_base = value
        } else {
          this.localNumBaseDigits = value
        }
      }
    },



  }
}
</script>

<style scoped></style>
